import { PrimaryButton } from "../Buttons/Buttons";
import { handleForm, handleChange } from "../../Utils/HandleForm";
import { store } from "react-notifications-component";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation, Trans } from "react-i18next";
import { t } from "i18next";

const Form = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    what: "",
    message: "",
  });

  function handler(e) {
    if (e.target.value !== "default") {
      const val = e.target.value.split(" ")[0].toLowerCase();
    }
    handleChange(e, setForm, form);
  }

  const [captcha, setCaptcha] = useState(false);
  const notification = {
    title: "Are you a robot?",
    message: "Mark your not a robot",
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
  };

  function onChange(value) {
    // console.log("Captcha value:", value);
    setCaptcha(!captcha);
  }

  function captchaNForm(e, store, form) {
    if (captcha !== false) {
      //     fwcrm.trackCustomEvent("Submit form", {
      //     name: "",
      //     phone: "",
      //     email: "",
      //     company:"",
      //     what:"",
      //     message:"",
      // })
      // const indentifier = '';
      // fwcrm.identify(indentifier, new_contact);
      //         handleForm(e, store, form)
    } else {
      store.addNotification(notification);
    }
  }

  // const new_contact = {

  // };

  return (
    <form action=''>
      <label htmlFor='name'>{t("description.name")}</label>
      <input
        type='text'
        required
        name='name'
        onChange={(e) => handleChange(e, setForm, form)}
      />
      <label htmlFor='phone'>
        <Trans i18nKey='description.phone' />
      </label>
      <input
        type='phone'
        required
        name='phone'
        onChange={(e) => handleChange(e, setForm, form)}
      />
      <label htmlFor='email'>
        <Trans i18nKey='description.email' />
      </label>
      <input
        type='email'
        required
        name='email'
        onChange={(e) => handleChange(e, setForm, form)}
      />
      <label htmlFor='company'>
        <Trans i18nKey='description.company' />
      </label>
      <input
        type='text'
        required
        name='company'
        onChange={(e) => handleChange(e, setForm, form)}
      />
      <label htmlFor='what'></label>
      <select required name='what' id='' onChange={(e) => handler(e)}>
        <option value='default'>{t("description.form1")}</option>
        <option value=''>{t("description.form2")}</option>
        <option value=''>{t("description.form3")}</option>
        <option value=''>{t("description.form4")}</option>
        <option value=''>{t("description.form5")}</option>
      </select>

      <label htmlFor='message'>{t("description.form6")}</label>
      <textarea
        name='textarea'
        onChange={(e) => handleChange(e, setForm, form)}
      />
      <ReCAPTCHA
        sitekey='6LemYDUbAAAAALQlr_DqeLeod97-5ipDDdUL3TCR'
        onChange={onChange}
      />
      <center style={{ paddingTop: "2em" }}>
        <PrimaryButton
          text={<Trans i18nKey='description.send' />}
          textColor='var(--white)'
          color='var(--primaryGreen)'
          onClick={(e) => captchaNForm(e, store, form)}
        />
      </center>
    </form>
  );
};

export default Form;
